export default "__VITE_ASSET__D3YH11XV__"